import { PRIOR_AUTHORIZATION_REJECT_CODES } from '@truepill/tpos-types'

const hasPriorAuthRejectCodes = (rejectCodes: { rejectCode: string }[] | undefined | null) =>
  rejectCodes?.some(({ rejectCode }) => PRIOR_AUTHORIZATION_REJECT_CODES.includes(rejectCode)) ?? false

export default hasPriorAuthRejectCodes
